import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { pixelViewContent, pixelAddToCart } from '../utils/pixel';

const ProductDetailPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [selectedWeight, setSelectedWeight] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [currentOriginalPrice, setCurrentOriginalPrice] = useState(0);
  const { addToCart } = useCart();

  useEffect(() => {
    fetchProduct();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (product && product.priceWeightList && product.priceWeightList.length > 0) {
      const defaultOption = product.priceWeightList[0];
      setSelectedWeight(defaultOption.weight);
      setCurrentPrice(defaultOption.price);
      setCurrentOriginalPrice(defaultOption.originalPrice);
    } else if (product) {
      setCurrentPrice(product.price);
      setCurrentOriginalPrice(product.originalPrice);
    }
  }, [product]);

  const fetchProduct = async () => {
    try {
      const response = await fetch(`/api/products/${id}`);
      const data = await response.json();
      setProduct(data);
      pixelViewContent(data);
    } catch (error) {
      console.error('Error fetching product:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = () => {
    const productToAdd = {
      ...product,
      selectedWeight,
      price: currentPrice
    };
    addToCart(productToAdd, quantity);
    pixelAddToCart(product, currentPrice);
    alert('Product added to cart!');
  };

  const handleWeightChange = (e) => {
    const weight = e.target.value;
    setSelectedWeight(weight);
    const selectedOption = product.priceWeightList.find(option => option.weight === weight);
    if (selectedOption) {
      setCurrentPrice(selectedOption.price);
      setCurrentOriginalPrice(selectedOption.originalPrice);
    }
  };

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (!product) return <div>Product not found</div>;

  return (
    <div className="product-detail-page">
      <div className="container">
        <div className="product-detail">
          <div className="product-image-large">
            <img src={product.image} alt={product.name} />
          </div>
          <div className="product-info-detailed">
            <h1>{product.name}</h1>
            <p className="product-description">{product.description}</p>
            <div className="product-price">
              <span className="current-price">₹{currentPrice}</span>
              {currentOriginalPrice && (
                <span className="original-price">₹{currentOriginalPrice}</span>
              )}
            </div>
            <div className="product-details">
              <p><strong>Weight:</strong> {product.weight}</p>
              <p><strong>Shelf Life:</strong> {product.shelfLife}</p>
              <p><strong>Stock:</strong> {product.stock} available</p>
            </div>
            {product.priceWeightList && product.priceWeightList.length > 0 && (
              <div className="weight-selector">
                <label>Size:</label>
                <select value={selectedWeight || ''} onChange={handleWeightChange}>
                  {product.priceWeightList.map((option) => (
                    <option key={option.weight} value={option.weight}>
                      {option.weight} - ₹{option.price}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="quantity-selector">
              <label>Quantity:</label>
              <input
                type="number"
                min="1"
                max={product.stock}
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
              />
            </div>
            <button 
              className="btn btn-primary btn-large"
              onClick={handleAddToCart}
              disabled={product.stock === 0}
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;